import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { PageTitle } from '../../components/PageTitle';


const StyledContactSection = styled.section.attrs({className: 'contact-section'})`
  background: #0F3F8E;
  color: #FFFFFF;
  border-radius: 20px;
  margin: 0 auto;
  max-width: var(--contents-maxwidth-pc);
  background-color: #0F3F8E;

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin: 120px 0;
    border-radius: 15px;
    
    /* Mobile-specific spacing */
    & > * + * {
      margin-top: 20px;
    }
  }
`;

const ContactContainer = styled.div.attrs({className: 'contact-container'})`
  padding: 80px 120px;
  margin: 95px auto;
  display: flex;
  align-items: flex-start;
  gap: 184px;

  @media (max-width: 768px) {
    padding: 20px 20px;
    margin: 0;
    flex-direction: column;
    gap: 30px;
  }

  .page-title-section {
    width: auto;
  }
  .page-title {
    color: #FFFFFF;
  }
`;



const ContactRightSide = styled.div.attrs({className: 'contact-right'})`
  flex: 1.5;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 768px) {
    order: 2;
    align-items: center;
  }
`;

const ContactSubtitle = styled.h3.attrs({className: 'contact-subtitle'})`
  font-family: 'ITC Avant Garde Gothic Pro', 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.2;
  letter-spacing: 0.05em;
  color: #84A0CD;
  margin: 0 0 40px 0;

  @media (max-width: 768px) {
    font-size: 18px;
    margin: 0 0 20px 0;
  }
`;

const ContactDescription = styled.p.attrs({className: 'contact-description'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.75;
  letter-spacing: 0.05em;
  margin: 0 0 40px 0;
  // max-width: 400px;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.6;
    margin: 0 0 30px 0;
    max-width: 100%;
  }
`;

const ContactButton = styled.p.attrs({className: 'contact-button'})`
  text-decoration: none;
  text-align: center;
  background: #F9FAFA;
  
  border: none;
  border-radius: 26px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 275px;
  height: 40px;
  align-self: end;
  a{
    display: block;
    width: 100%;
    height: 100%;
    font-family: 'Noto Sans JP', sans-serif;
    font-weight: 700;
    font-size: 13px;
    line-height: 1.38;
    letter-spacing: 0.05em;
    padding: 10px 29px 11px;
    color: #0F3F8E;
    text-decoration: none;
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
  &:hover {
    background: #E5E5E5;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 275px;
    height: 44px;
    min-height: 44px; /* Touch-friendly button size */
    align-self: center;
    margin-top: 20px;
  }
`;

export const ContactSection = () => {
  return (
    <>
      <StyledContactSection>
        <ContactContainer>
          {/* Page Title Section */}
          <PageTitle title={ 'お問合わせ' } subtitle={ 'Contact' } />
          <ContactRightSide>
            <ContactDescription>
              システム開発 / AI関連 / ウェブサイト制作 / デジタルマーケティング / 取材等のお問い合わせに関して
            </ContactDescription>
            <ContactButton><a href="/contact/">いますぐ問い合わせる</a></ContactButton>
          </ContactRightSide>
        </ContactContainer>
      </StyledContactSection>
    </>
  );
};


